<template>
  <div class="main">
    <div class="back_wrapper">
      <div class="back_btn" @click="goback"><van-icon name="arrow-left" size="0.3rem" color="#6ca5ce" />返回</div>
      <div class="back_title">健康科普</div>
    </div>
    <div class="header_wrapper"><img src="./static/p1.png" alt="" class="img" /></div>
    <div class="tabbar_wrapper">
      <!-- <div class="tab_item" :class="{ tabact: active == tabindex }" v-for="(tabname, tabindex) in tablist" :key="tabindex" @click="changeTab(tabindex)">{{ tabname }}</div> -->
      <van-tabs class="my_tabs" v-model="active" @click="changeTabMy" color="#1F62D4" title-inactive-color="#1D2129" title-active-color="#1F62D4">
        <van-tab title-class="my_tab_item" v-for="(tabname, tabindex) in tablist" :key="tabindex" :title="tabname"></van-tab>
      </van-tabs>
    </div>
    <div class="search_wrapper" v-show="active == 4">
      <van-search v-model="keyword" show-action label="" placeholder="请输入要查询的内容" @search="$_debounce(onSearch)" @blur="$_debounce(onSearch)">
        <template #action>
          <!-- <van-icon name="search" class="search_icon" @click="$_debounce(onSearch)" size="0.4rem" color="#A6A6A6" /> -->
          <div class="search_btn" @click="$_debounce(onSearch)">查询</div>
        </template>
      </van-search>
      <!-- <div class="search_box">
        <input type="text" class="search_input" v-model="keyword" placeholder="请输入搜索关键词" @keydown.enter="$_debounce(onSearch)" @blur="$_debounce(onSearch)" />
        <div class="search_btn" @click="$_debounce(onSearch)">搜索</div>
      </div> -->
    </div>
    <div class="content_wrapper">
      <section v-show="active == 0" class="list_wrapper">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="item_wrapper" v-for="(item, index) in list" :key="'tab0' + index" @click="goDetail(item)">
            <div class="item_main">
              <div class="item_main_left"><img :src="item.j_thumb" alt="" class="img" /></div>
              <div class="item_main_right">
                <div class="item_title">{{ item.j_title }}</div>
                <div class="item_num_box">
                  <div class="item_num"><van-icon class="sicon" name="eye-o" size="0.3rem" />{{ item.j_hot }}</div>
                </div>
              </div>
            </div>
            <div class="item_from">
              <div class="item_com">{{ item.j_copyfrom }}</div>
              <div class="item_date"><van-icon class="sicon" name="clock-o" />{{ item.j_created }}</div>
            </div>
          </div>
        </van-list>
      </section>
      <section v-show="active == 1" class="list_wrapper">
        <van-list v-model="loading1" :finished="finished1" finished-text="没有更多了" @load="onLoad">
          <div class="item_wrapper" v-for="(item, index) in list1" :key="'tab1' + index" @click="goDetail(item)">
            <div class="item_main">
              <div class="item_main_left"><img :src="item.j_thumb" alt="" class="img" /></div>
              <div class="item_main_right">
                <div class="item_title">{{ item.j_title }}</div>
                <div class="item_num_box">
                  <div class="item_num"><van-icon class="sicon" name="eye-o" size="0.3rem" />{{ item.j_hot }}</div>
                </div>
              </div>
            </div>
            <div class="item_from">
              <div class="item_com">{{ item.j_copyfrom }}</div>
              <div class="item_date"><van-icon class="sicon" name="clock-o" />{{ item.j_created }}</div>
            </div>
          </div>
        </van-list>
      </section>
      <section v-show="active == 2" class="list_wrapper">
        <van-list v-model="loading2" :finished="finished2" finished-text="没有更多了" @load="onLoad">
          <div class="item_wrapper" v-for="(item, index) in list2" :key="'tab2' + index" @click="goDetail(item)">
            <div class="item_main">
              <div class="item_main_left"><img :src="item.j_thumb" alt="" class="img" /></div>
              <div class="item_main_right">
                <div class="item_title">{{ item.j_title }}</div>
                <div class="item_sort">
                  <!-- <div class="item_mc">名次：1</div> -->
                  <div class="item_total">总票数：{{ item.j_vote }}</div>
                </div>
                <div class="item_num_box">
                  <div class="item_num"><van-icon class="sicon" name="eye-o" size="0.3rem" />{{ item.j_hot }}</div>
                  <div class="item_vote_btn" @click.stop="gotoVote(item)">投票</div>
                </div>
              </div>
            </div>
            <div class="item_from">
              <div class="item_com">{{ item.j_copyfrom }}</div>
              <div class="item_date"><van-icon class="sicon" name="clock-o" />{{ item.j_created }}</div>
            </div>
          </div>
        </van-list>
      </section>
      <section v-show="active == 3" class="list_wrapper">
        <div class="introduce_wrapper">河南手机报创办于2006年5月15日，是全国第三份、河南省第一份手机报，用户规模破千万。2008年12月20日河南手机报订阅用户达到107万人，成为全国发行量最大的手机报，是全国省级手机报的标杆和楷模，也是目前国内读者最多、影响力最大的手机报之一。<br />《健康科普》专栏致力于创作、传播健康科普内容，推动健康知识普及。相关栏目投稿或建议请点击<a href="https://www.hnsjb.cn/show/xjhealth/72b06c199334f4c0e558cdb7f92a4fa.jpg">联系我们</a>。</div>
      </section>
      <section v-show="active == 4" class="list_wrapper">
        <van-list v-model="loading4" :finished="finished4" finished-text="没有更多了" @load="onLoad" v-if="list4.length">
          <div class="item_wrapper" v-for="(item, index) in list4" :key="'tab2' + index" @click="goDetail(item)">
            <div class="item_main">
              <div class="item_main_left"><img :src="item.j_thumb" alt="" class="img" /></div>
              <div class="item_main_right">
                <div class="item_title">{{ item.j_title }}</div>
                <div class="item_sort" v-if="item.j_catid == 206">
                  <!-- <div class="item_mc">名次：1</div> -->
                  <div class="item_total">总票数：{{ item.j_vote }}</div>
                </div>
                <div class="item_num_box">
                  <div class="item_num"><van-icon class="sicon" name="eye-o" size="0.3rem" />{{ item.j_hot }}</div>
                  <div class="item_vote_btn" v-if="item.j_catid == 206" @click.stop="gotoVote(item)">投票</div>
                </div>
              </div>
            </div>
            <div class="item_from">
              <div class="item_com">{{ item.j_copyfrom }}</div>
              <div class="item_date"><van-icon class="sicon" name="clock-o" />{{ item.j_created }}</div>
            </div>
          </div>
        </van-list>
        <van-empty description="暂无数据" v-else />
      </section>
    </div>
    <van-overlay :show="dialog_show" @click="dialog_show = false" class="dialog_container">
      <div class="dialog_wrapper" @click.stop>
        <van-form @submit="onSubmit">
          <div class="dialog_code" @click="gorefreshCode">
            <img :src="codeurl + datestr" alt="" class="img" :key="refreshcode" />
          </div>
          <van-field v-model="code" name="code" label="验证码" placeholder="验证码" :rules="[{ required: true, message: '请填写验证码' }]" :key="refreshinput" />
          <div class="btn_box">
            <!-- <van-button round block type="default" @click.stop="gocancel" class="btn">取消</van-button> -->
            <van-button round block type="info" native-type="submit" class="btn">提交</van-button>
          </div>
        </van-form>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { toQueryString, detectDevice } from './assets/jfun.js';
export default {
  name: 'Health',
  data() {
    return {
      datestr: '',
      codeurl: 'https://www.hnsjb.cn/api.php?op=checkcode&v=',
      refreshinput: false,
      curvoteid: '',
      refreshcode: false,
      code: '',
      dialog_show: false,
      limit: 20,
      tablist: ['科普图文', '科普视频', '科普征集', '栏目介绍', '科普查询'],
      active: 0,
      keyword: '',
      list: [],
      page: 1,
      loading: false,
      finished: false,
      list1: [],
      page1: 1,
      loading1: false,
      finished1: false,
      list2: [],
      page2: 1,
      loading2: false,
      finished2: false,
      list4: [],
      page4: 1,
      loading4: false,
      finished4: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    /*** 返回上一页 */
    goback() {
      // window.history.back();
      window.location.replace('https://www.hnsjb.cn/content/specailist/index.html');
    },
    /*** 刷新验证码 */
    gorefreshCode() {
      this.refreshcode = !this.refreshcode;
      this.datestr = new Date().getTime();
    },
    /*** 提交投票 */
    onSubmit(values) {
      if (this.curvoteid && values.code) {
        const formData = new FormData();
        formData.append('id', this.curvoteid);
        formData.append('verify', values.code);
        this.$http.post('/api.php?op=getJiankangkepuVote', formData).then((res) => {
          if (res.data == 1) {
            // 成功
            this.$toast('投票成功');
            // 更改对应的票数
            let obj = {};
            if (this.active == 2) {
              obj = this.list2.find((item) => item.id == this.curvoteid);
            } else if (this.active == 4) {
              obj = this.list4.find((item) => item.id == this.curvoteid);
            }
            if (obj) {
              obj.j_vote = parseInt(obj.j_vote) + 1;
            }
            this.dialog_show = false;
            this.curvoteid = '';
            this.code = '';
          } else {
            // 失败
            this.$toast('验证码错误');
            this.gorefreshCode();
            this.refreshinput = !this.refreshinput;
            this.code = '';
          }
        });
      } else {
        console.log('缺少参数');
      }
    },
    /*** 开始投票 */
    gotoVote(row) {
      this.dialog_show = true;
      this.gorefreshCode();
      this.refreshinput = !this.refreshinput;
      this.curvoteid = row.id;
      this.code = '';
    },
    getBlur() {
      // const deviceInfo = detectDevice();
      // if (deviceInfo.isMobile) {
      //   if (deviceInfo.isiOS) {
      //     // iOS设备特定逻辑
      //     console.log('执行iOS移动端优化');
      //   } else if (deviceInfo.isAndroid) {
      //     // Android设备特定逻辑
      //     console.log('执行Android移动端优化');
      //   }
      // } else {
      //   // PC端逻辑
      //   console.log('执行PC端优化');
      // }
    },
    /*** 查询 */
    async onSearch() {
      this.list4 = [];
      this.page4 = 1;
      this.loading4 = false;
      this.finished4 = false;
      this.onLoad();
    },
    /*** 格式化数据 */
    turnData(data) {
      let arr = [];
      if (data.length) {
        arr = data.map((item) => {
          item.j_title = item.title || '';
          item.j_copyfrom = item.copyfrom || '';
          // if (item.thumb) {
          //   const prefix = 'https://newsplatform.hnsjb.cn';
          //   if (item.thumb.startsWith(prefix)) {
          //     item.j_thumb = item.thumb;
          //   } else {
          //     item.j_thumb = prefix + item.thumb;
          //   }
          // } else {
          //   item.j_thumb = require('./static/p1.png');
          // }
          item.j_thumb = require('./static/p2.jpg');
          item.j_created = item.created || '';
          item.j_url = item.url || '';
          item.j_hot = item.hot || '0';
          item.j_vote = item.vote || '0';
          item.j_catid = item.catid || '';
          return item;
        });
      }
      return arr;
    },
    /*** 详情 */
    goDetail(row) {
      if (row.j_url) {
        window.location.href = row.j_url;
        // if (row.j_catid == '204' || row.j_catid == '205') {
        // }
      } else {
        this.$toast('暂无详情链接');
      }
    },
    /*** 列表接口 */
    getList(param) {
      return new Promise((resolve) => {
        let paramstr = toQueryString(param);
        this.$http.get('/api.php?' + paramstr).then((res) => {
          if (res.status == 200) {
            resolve({ status: 'ok', data: res.data });
          } else {
            resolve({ status: 'err' });
          }
        });
      });
    },
    changeTabMy(name, title) {
      this.changeTab(name);
    },
    /*** 页签切换 */
    changeTab(index) {
      this.active = index;
      if (index == 0 && this.page == 1) {
        if (!this.list.length) {
          this.finished = false;
        }
        this.onLoad();
      } else if (index == 1 && this.page1 == 1) {
        if (!this.list1.length) {
          this.finished1 = false;
        }
        this.onLoad();
      } else if (index == 2 && this.page2 == 1) {
        if (!this.list2.length) {
          this.finished2 = false;
        }
        this.onLoad();
      }
    },
    /*** 上拉下一页 */
    async onLoad() {
      switch (this.active) {
        case 0: {
          // 图文
          if (this.finished) {
            // console.log('图文已加载完');
            return;
          }
          this.loading = true;
          const res = await this.getList({
            page: this.page,
            catid: 204,
            limit: this.limit,
            op: 'getJiankangkepu',
          });
          this.loading = false;
          if (res.status == 'ok') {
            this.list = [...this.list, ...res.data.list];
            this.list = this.turnData(this.list);
            if (res.data.list.length < this.limit || (this.list.length > 0 && this.list.length >= res.data.count)) {
              this.finished = true;
            } else {
              this.page++;
            }
          } else {
            this.finished = true;
          }
          break;
        }
        case 1: {
          // 视频
          if (this.finished1) {
            // console.log('视频已加载完');
            return;
          }
          this.loading1 = true;
          const res1 = await this.getList({
            page: this.page1,
            catid: 205,
            limit: this.limit,
            op: 'getJiankangkepu',
          });
          this.loading1 = false;
          if (res1.status == 'ok') {
            this.list1 = [...this.list1, ...res1.data.list];
            this.list1 = this.turnData(this.list1);
            if (res1.data.list.length < this.limit || (this.list1.length > 0 && this.list1.length >= res1.data.count)) {
              this.finished1 = true;
            } else {
              this.page1++;
            }
          } else {
            this.finished1 = true;
          }
          break;
        }
        case 2: {
          // 比赛
          if (this.finished2) {
            return;
          }
          this.loading2 = true;
          const res2 = await this.getList({
            page: this.page2,
            catid: 206,
            limit: this.limit,
            op: 'getJiankangkepu',
          });
          this.loading2 = false;
          if (res2.status == 'ok') {
            this.list2 = [...this.list2, ...res2.data.list];
            this.list2 = this.turnData(this.list2);
            if (res2.data.list.length < this.limit || (this.list2.length > 0 && this.list2.length >= res2.data.count)) {
              this.finished2 = true;
            } else {
              this.page2++;
            }
          } else {
            this.finished2 = true;
          }
          break;
        }
        case 4: {
          // 混合查询
          if (this.finished4) {
            return;
          }
          this.loading4 = true;
          const res4 = await this.getList({
            page: this.page4,
            keyword: this.keyword,
            limit: this.limit,
            op: 'getJiankangkepuSearch',
          });
          this.loading4 = false;
          if (res4.status == 'ok') {
            this.list4 = [...this.list4, ...res4.data.list];
            this.list4 = this.turnData(this.list4);
            if (res4.data.list.length < this.limit || (this.list4.length > 0 && this.list4.length >= res4.data.count)) {
              this.finished4 = true;
            }
            this.page4++;
          } else {
            this.finished4 = true;
          }
          break;
        }
        default: {
          break;
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import './assets/base.css';
</style>
<style lang="less" scoped>
.main {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  .back_wrapper {
    flex: 0 0 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-bottom: 1px solid #e6e6e6;
    .back_btn {
      position: absolute;
      left: 0.24rem;
      top: 0;
      z-index: 2;
      width: 1.2rem;
      height: 0.9rem;
      line-height: 0.9rem;
      cursor: pointer;
      white-space: nowrap;
      font-size: 0.32rem;
      color: #6ca5ce;
      .van-icon {
        margin-right: 0.1rem;
        font-weight: bold;
      }
    }
    .back_title {
      font-size: 0.36rem;
      color: #6ca5ce;
    }
  }
  .header_wrapper {
    flex: 0 0 3.82rem;
    aspect-ratio: 752/383;
  }
  .tabbar_wrapper {
    flex: 0 0 0.45rem;
    flex: 0 0 0.8rem;
    padding: 0 0.2rem;
    display: flex;
    align-items: center;
    overflow: hidden;
    border-bottom: 1px solid #d8d8d8;
    .my_tabs {
      width: 100%;
      height: 100%;
      ::v-deep {
        .van-tabs__wrap {
          height: 100%;
          .van-tabs__nav {
            padding-bottom: 0;
          }
        }
        .my_tab_item {
          line-height: initial;
          height: 100%;
          .van-tab__text {
            font-size: 0.28rem;
            font-weight: bold;
          }
        }
        .van-tabs__line {
          bottom: 0;
          width: 0.8rem;
          height: 0.08rem;
        }
      }
    }
    .tab_item {
      font-size: 0.28rem;
      color: #86909c;
      white-space: nowrap;
      cursor: pointer;
      &.tabact {
        color: #1d2129;
      }
      &:not(:last-child) {
        &::after {
          content: '/';
          margin: 0 0.1rem;
          color: #86909c;
        }
      }
    }
  }
  .search_wrapper {
    ::v-deep {
      .van-field__left-icon {
        display: none;
      }
      .van-search__content {
        border: 1px solid #010814;
      }
    }
    .search_btn {
      background-color: #3662ec;
      border-radius: 0.05rem;
      width: 1.3rem;
      height: 0.5rem;
      line-height: 0.5rem;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
    .search_box {
      display: flex;
      align-items: center;
      background: pink;
      height: 0.8rem;
      white-space: nowrap;
      padding: 0 0.2rem;
      .search_input {
        background-color: red;
        height: 0.7rem;
        margin-right: 0.2rem;
        flex: 1;
        padding: 0 0.1rem;
        font-size: 0.25rem;
      }
    }
  }
  .content_wrapper {
    flex: 1;
    overflow: hidden;
    .list_wrapper {
      height: 100%;
      overflow-y: auto;
    }
    .item_wrapper {
      border-bottom: 1px solid #d8d8d8;
      padding: 0.2rem 0 0.1rem 0;
      .item_main {
        display: flex;
        justify-content: space-between;
        .item_main_left {
          margin: 0.06rem 0.44rem 0.28rem 0.16rem;
          width: 2.7rem;
          height: 2rem;
          flex-shrink: 0;
          flex-grow: 0;
        }
        .item_main_right {
          flex: 1;
          overflow: hidden;
          margin-right: 0.4rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .item_title {
            font-size: 0.32rem;
            line-height: 1.6;
            display: -webkit-box;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            color: #1d2129;
          }
          .item_sort {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-right: 0.1rem;
            text-align: right;
            overflow: hidden;
            white-space: nowrap;
            color: #db5959;
            .item_mc {
              padding-right: 0.2rem;
              flex: 0 0 40%;
              overflow: hidden;
            }
            .item_total {
              flex: 0 0 60%;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .item_num_box {
            display: flex;
            justify-content: space-between;
            align-items: end;
          }
          .item_num {
            font-size: 0.24rem;
            color: #91929f;
            display: flex;
            align-items: end;
            .sicon {
              margin-right: 0.05rem;
            }
          }
          .item_vote_btn {
            width: 1.2rem;
            height: 0.6rem;
            line-height: 0.6rem;
            background-color: #3662ec;
            font-size: 0.3rem;
            color: #fff;
            border-radius: 2px;
            text-align: center;
            cursor: pointer;
          }
        }
      }
      .item_from {
        margin: 0 0.4rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.24rem;
        display: flex;
        align-items: center;
        white-space: nowrap;
        overflow: hidden;
        color: #3d3d3d;
        .item_com {
          margin-right: 0.3rem;
          max-width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .item_date {
          .sicon {
            margin-right: 0.05rem;
          }
        }
      }
      &:first-child {
        padding-top: 0;
      }
    }
    .introduce_wrapper {
      font-size: 0.24rem;
      color: #3d3d3d;
      padding: 0 0.28rem;
      line-height: 2;
      a {
        color: #3662ec;
        display: inline-block;
        cursor: pointer;
      }
    }
  }
  .dialog_container {
    position: absolute;
    z-index: 9;
    .dialog_wrapper {
      width: 80%;
      margin: 0 auto;
      margin-top: 45%;
      background-color: #fff;
      border-radius: 0.3rem;
      overflow: hidden;
      .dialog_code {
        width: 1.5rem;
        height: 1rem;
        margin: 0.2rem auto;
        .img {
          object-fit: contain;
        }
      }
      .btn_box {
        display: flex;
        align-items: center;
        margin: 0.16rem 0;
        .btn {
          margin: 0 0.2rem;
        }
      }
    }
  }
}
</style>
